import { css } from "styled-components";
import { ctaCursorMixin } from "../mixins";
export const playSkin = (chroma) => css `
  ${ctaCursorMixin}

  &.variant-primary {
    display: inline-flex;
    font-family: "FF Mark W05", sans-serif;
    background: ${chroma.components.cta_default_background};
    color: ${chroma.components.cta_default_foreground};
    height: 64px;
    padding: 0 16px;
    border-radius: 24px;
    border: none;
    text-decoration: none;
    font-size: 20px;
    font-weight: 700;
    align-items: center;
    justify-content: center;
    margin: 0.2em;

    &:disabled {
      background: ${chroma.components.cta_disabled_background};
      color: ${chroma.components.cta_disabled_foreground};
      border: 1px solid ${chroma.components.cta_disabled_border};
    }

    &:active {
      background: ${chroma.components.cta_active_background};
    }

    &:focus {
      outline: ${chroma.components.cta_focus_border} solid 2px;
      outline-offset: 2px;
    }

    &:hover:not(.disabled) {
      background: ${chroma.components.cta_hover_background};
    }
    ${chroma.mediaQueries.desktopDown} {
      height: 48px;
      border-radius: 9.6px;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0;
    }
    ${chroma.mediaQueries.tabletDown} {
      height: 32px;
      padding: 0 12px;
      border-radius: 6.4px;
      font-size: 12.6px;
      line-height: 14px;
      letter-spacing: 0.08em;
    }
    ${chroma.mediaQueries.mobileDown} {
      height: 24px;
      border-radius: 4.8px;
      font-size: 13px;
    }
  }
`;
//# sourceMappingURL=index.js.map